import { render, staticRenderFns } from "./StrokeAttrsItem.vue?vue&type=template&id=bc51580a&"
import script from "./StrokeAttrsItem.vue?vue&type=script&lang=js&"
export * from "./StrokeAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc51580a')) {
      api.createRecord('bc51580a', component.options)
    } else {
      api.reload('bc51580a', component.options)
    }
    module.hot.accept("./StrokeAttrsItem.vue?vue&type=template&id=bc51580a&", function () {
      api.rerender('bc51580a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/items/StrokeAttrsItem.vue"
export default component.exports